import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import ASK_SENIOR_V3_BASE_URL from "../../constants";

// sendQuestions thunk
export const sendQuestions = createAsyncThunk("sendQuestions", async (data) => {
  const response = await axios.post("/questions", {
    questions: data.questions,
    tags: data.tags,
    difficulty: data.difficulty,
    likes: 0,
    dislikes: 0,
  });
  return response.data;
});

// submitQuestionLink thunk
export const submitQuestionLink = createAsyncThunk(
  "submitQuestionLink",
  async (data) => {
    const url = data.apiEndpoint;
    delete data.apiEndpoint;
    const response = await axios.post(`${ASK_SENIOR_V3_BASE_URL}/${url}`, data);
    return response.data;
  }
);

const sendQuestionsSlice = createSlice({
  name: "questions",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    submitLinkLoading: false,
    submitLinkError: false,
    submitLinkSuccess: false,
  },
  extraReducers: (builder) => {
    builder.addCase(sendQuestions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(sendQuestions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(sendQuestions.rejected, (state, action) => {
      console.log("Error in sendQuestions", action.error);
      state.isLoading = false;
      state.isError = true;
    });

    // submitQuestionLink handlers
    builder.addCase(submitQuestionLink.pending, (state) => {
      state.submitLinkLoading = true;
      state.submitLinkError = false;
      state.submitLinkSuccess = false;
    });
    builder.addCase(submitQuestionLink.fulfilled, (state, action) => {
      state.submitLinkLoading = false;
      state.submitLinkSuccess = true;
    });
    builder.addCase(submitQuestionLink.rejected, (state, action) => {
      console.log("Error in submitQuestionLink", action.error);
      state.submitLinkLoading = false;
      state.submitLinkError = true;
    });
  },
});

export default sendQuestionsSlice.reducer;
